import { IWindow } from '../types';

export const isCypressInstance =
    typeof window !== 'undefined' &&
    (window as IWindow & typeof globalThis).Cypress;
